export default __webpack_public_path__ + "static/media/unpaid-leave.14155db6.svg";